/* eslint-disable no-param-reassign, no-shadow */
import mutationTypes from '../mutation-types'
import { repairState, resetState } from '../state-helper'

// initial state
function initialState () {
  return {
    token: null,
    expire: null, // storing that because of performance
  }
}
const state = initialState()

// extract the expire time from the token header
function extractExpireTime(token) {
  return JSON.parse(window.atob(token.split('.')[1])).exp
}

// check if the expire time has been reached
// no time means no token means expired!
function isExpired(expireTime) {
  if (!expireTime) return true
  return new Date(expireTime * 1000) < new Date()
}
// check if the expire time has not been reached
function isNotExpired(expireTime) {
  return !isExpired(expireTime)
}
// getters
const getters = {
  isAuthenticated: (state) => state.token !== null && isNotExpired(state.expire),
  getAuthenticationToken: (state) => state.token,
}

// actions
const actions = {
}

// mutations
const mutations = {
  repairAuthenticationState (state) {
    repairState(state, initialState())
  },

  resetAuthenticationState (state) {
    resetState(state, initialState())
  },

  [mutationTypes.SET_AUTHENTICATION] (state, token) {
    state.token = token
    state.expire = extractExpireTime(token)
  },

  [mutationTypes.RESET_AUTHENTICATION] (state) {
    state.token = null
    state.expire = null
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
